// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  height: 6rem;
  padding: 1.8rem 2rem 1.8rem 3.8rem;
  background: var(--white);
}`, "",{"version":3,"sources":["webpack://./src/shared/overlay-side-panel/components/overlay-side-panel-header/overlay-side-panel-header.component.ts"],"names":[],"mappings":"AACM;EACE,aAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,kCAAA;EACA,wBAAA;AAAR","sourcesContent":["\n      :host {\n        display: flex;\n        flex: none;\n        align-items: center;\n        justify-content: space-between;\n        height: 6rem;\n        padding: 1.8rem 2rem 1.8rem 3.8rem;\n        background: var(--white);\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
